import '.h{width:100%;}.ssr-plugin'
import '.dw{border-radius:0.75rem;}.ssr-plugin'
import '.f6{border:1px solid var(--palette-blue-300);}.ssr-plugin'
import '.f4{padding:0.5rem 1rem;}.ssr-plugin'
import '.ds{font-size:1.125rem;}.ssr-plugin'
import '.f7{line-height:1.75rem;}.ssr-plugin'
import '.f8{resize:vertical;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { forwardRef } from 'react'

export type MultiLineTextInputProps = {
  value: string
  placeholder?: string
  minHeight?: string
  style?: Style
  setValue: (value: string) => void
}

export const MultiLineTextInput = forwardRef<
  HTMLTextAreaElement,
  MultiLineTextInputProps
>(
  (
    {
      value,
      placeholder,
      minHeight = '6.5rem',
      style,
      setValue,
    }: MultiLineTextInputProps,
    ref,
  ) => {
    return (
      <styled.textarea className="h dw f6 f4 ds f7 f8"
        ref={ref}
        style={{
          minHeight: minHeight,
          '&:focus': {
            outline: 'none',
            border: '1px solid var(--brand-secondary)',
          },
          ...style,
        }}
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      ></styled.textarea>
    )
  },
)
